export const FORMULARIO_PROYECTO = 'FORMULARIO_PROYECTO'
export const OBTENER_PROYECTOS = 'OBTENER_PROYECTOS'
export const AGREGAR_PROYECTO = 'AGREGAR_PROYECTO';
export const VALIDAR_FORMULARIO = 'VALIDAR_FORMULARIO';
export const PROYECTO_ACTUAL = 'PROYECTO_ACTUAL';
export const ELIMINAR_PROYECTO = 'ELIMINAR_PROYECTO';
export const PROYECTO_ERROR = 'PROYECTO_ERROR';

export const CRITICAS_PROYECTO = 'CRITICAS_PROYECTO';
export const AGREGAR_CRITICA = 'AGREGAR_CRITICA';
export const VALIDAR_CRITICA = 'VALIDAR_CRITICA';
export const ELIMINAR_CRITICA = 'ELIMINAR_CRITICA';
export const CRITICA_ACTUAL = 'CRITICA_ACTUAL';
export const ACTUALIZAR_CRITICA = 'ACTUALIZAR_CRITICA';
export const LIMPIAR_CRITICA = 'LIMPIAR_CRITICA';
export const MOSTRAR_FORMULARIO = 'MOSTRAR_FORMULARIO';

export const MOSTRAR_ALERTA = 'MOSTRAR_ALERTA';
export const OCULTAR_ALERTA = 'OCULTAR_ALERTA';

export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';
export const GUARDAR_CARGANDO = 'GUARDAR_CARGANDO';